import React from 'react';
import PropTypes from 'prop-types';
import DropDown from '../../../../components/dropdown/DropDown';
import './BookNavigation.scss';

const BookNavigation = ({ className, books, selectedBook, selectBook, location }) => (
    <div className={`level-name-holder ${className}`}>
        <h4 className="style-white">{selectedBook.title}</h4>
        <div className="single-select-demo" id="single-select-demo">
            <DropDown
                onDropDownItemClick={bookId => selectBook(bookId, location)}
                chosenItem={selectedBook}
                items={books}
                isDisabled={books.length <= 1}
                buttonClassNames="small"
            />
        </div>
    </div>
);

BookNavigation.defaultProps = {
    className: '',
    books: [],
    selectedBook: {},
    selectBook: () => {},
    location: {},
};

BookNavigation.propTypes = {
    className: PropTypes.string,
    books: PropTypes.arrayOf(
        PropTypes.shape({
            uid: PropTypes.string,
            name: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
            title: PropTypes.string,
        }),
    ),
    selectedBook: PropTypes.shape({
        uid: PropTypes.string,
        name: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        title: PropTypes.string,
    }),
    selectBook: PropTypes.func,
    location: PropTypes.object,
};

export default BookNavigation;
